import React from "react";
import SettingsLayout from "../pages/settings/SettingsLayout";

const Settings = () => {
    return <SettingsLayout />;
};

export default Settings;
